import Updater from './Updater';
import { APPLICATION } from 'StateEvents';
import { getInstance } from '../StateManager';
import { unique } from 'Services/Misc/collections';

export class ApplicationUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(APPLICATION);
  }

  updateState(newState, event) {
    switch(event.name) {
      case APPLICATION.ERROR:
        newState.errors = newState.errors.concat(event.args).reduce(unique, []);
        break;
      case APPLICATION.ERROR_LOGGED:
        newState.media.stopped = true;
        break;
    }

    return newState;
  }
}

getInstance().registerUpdater(new ApplicationUpdater(), 0);


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/ApplicationUpdater.js